/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFProcessShort } from './CRSFProcessShort';
import {
    CRSFProcessShortFromJSON,
    CRSFProcessShortFromJSONTyped,
    CRSFProcessShortToJSON,
} from './CRSFProcessShort';

/**
 * 
 * @export
 * @interface CRSFProcessShortPagedResponse
 */
export interface CRSFProcessShortPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFProcessShortPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFProcessShortPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFProcessShort>}
     * @memberof CRSFProcessShortPagedResponse
     */
    results?: Array<CRSFProcessShort>;
    /**
     * 
     * @type {number}
     * @memberof CRSFProcessShortPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFProcessShortPagedResponse interface.
 */
export function instanceOfCRSFProcessShortPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFProcessShortPagedResponseFromJSON(json: any): CRSFProcessShortPagedResponse {
    return CRSFProcessShortPagedResponseFromJSONTyped(json, false);
}

export function CRSFProcessShortPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFProcessShortPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFProcessShortFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFProcessShortPagedResponseToJSON(value?: CRSFProcessShortPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFProcessShortToJSON)),
        'total': value.total,
    };
}

